/* tslint:disable */
/* This is generated by ts_routes-rails */

export type ScalarType = string | number | boolean;

function $buildOptions(options: any, names: string[]): string {
  if (options) {
    let anchor = "";
    const q = [] as string[];
    for (const key of Object.keys(options)) {
      if (names.indexOf(key) !== -1) {
        // the key is already consumed
        continue;
      }

      const value = options[key];

      if (key === "anchor") {
        anchor = `#${$encode(value)}`;
      } else {
        $buildQuery(q, key, value);
      }
    }
    return (q.length > 0 ? "?" + q.join("&") : "") + anchor;
  } else {
    return "";
  }
}

function $buildQuery(q: string[], key: string, value: any) {
  if ($isScalarType(value)) {
    q.push(`${$encode(key)}=${$encode(value)}`);
  } else if (Array.isArray(value)) {
    for (const v of value) {
      $buildQuery(q, `${key}[]`, v);
    }
  } else if (value != null) {
    // i.e. non-null, non-scalar, non-array type
    for (const k of Object.keys(value)) {
      $buildQuery(q, `${key}[${k}]`, value[k]);
    }
  }
}

function $encode(value: any): string {
  return encodeURIComponent(value);
}

function $isScalarType(value: any): value is ScalarType {
  return (
    typeof value === "string" ||
    typeof value === "number" ||
    typeof value === "boolean"
  );
}

function $isPresent(value: any): boolean {
  return value != null && ("" + value).length > 0;
}

function $hasPresentOwnProperty(options: any, key: string): boolean {
  return options && options.hasOwnProperty(key) && $isPresent(options[key]);
}

/** /manifest(.:format) */
export function manifestPath(options?: object): string {
  return "/" + "manifest" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/console(.:format) */
export function apiConsolePath(options?: object): string {
  return "/" + "api" + "/" + "console" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/graphiql */
export function graphiqlPath(options?: object): string {
  return "/" + "api" + "/" + "graphiql" + $buildOptions(options, []);
}

/** /api/internal(.:format) */
export function apiInternalPath(options?: object): string {
  return "/" + "api" + "/" + "internal" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1(.:format) */
export function apiV1Path(options?: object): string {
  return "/" + "api" + "/" + "v1" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api/v1/console(.:format) */
export function consolePath(options?: object): string {
  return "/" + "api" + "/" + "v1" + "/" + "console" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /my_feed(.:format) */
export function myFeedPath(options?: object): string {
  return "/" + "my_feed" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /all(.:format) */
export function allPath(options?: object): string {
  return "/" + "all" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password/new(.:format) */
export function newUserPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password/edit(.:format) */
export function editUserPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/password(.:format) */
export function userPasswordPath(options?: object): string {
  return "/" + "users" + "/" + "password" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/confirmation/new(.:format) */
export function newUserConfirmationPath(options?: object): string {
  return "/" + "users" + "/" + "confirmation" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/confirmation(.:format) */
export function userConfirmationPath(options?: object): string {
  return "/" + "users" + "/" + "confirmation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/unlock/new(.:format) */
export function newUserUnlockPath(options?: object): string {
  return "/" + "users" + "/" + "unlock" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/unlock(.:format) */
export function userUnlockPath(options?: object): string {
  return "/" + "users" + "/" + "unlock" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /signin(.:format) */
export function newUserSessionPath(options?: object): string {
  return "/" + "signin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /signin(.:format) */
export function userSessionPath(options?: object): string {
  return "/" + "signin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /signout(.:format) */
export function destroyUserSessionPath(options?: object): string {
  return "/" + "signout" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/profile(.:format) */
export function profileSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "profile" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/after_sign_up(.:format) */
export function afterSignUpSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "after_sign_up" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/password(.:format) */
export function passwordSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "password" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/notifications(.:format) */
export function notificationsSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "notifications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/preferences(.:format) */
export function preferencesSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "preferences" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/update_locale(.:format) */
export function updateLocaleSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "update_locale" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/avatar(.:format) */
export function avatarSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "avatar" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/cover_image(.:format) */
export function coverImageSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "cover_image" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/uploaded_files(.:format) */
export function uploadedFilesSettingsPath(options?: object): string {
  return "/" + "settings" + "/" + "uploaded_files" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/access_tokens(.:format) */
export function personalAccessTokensPath(options?: object): string {
  return "/" + "settings" + "/" + "access_tokens" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings/access_tokens/:id(.:format) */
export function personalAccessTokenPath(id: ScalarType, options?: object): string {
  return "/" + "settings" + "/" + "access_tokens" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/access_token_logs(.:format) */
export function teamPersonalAccessTokenLogsPath(options?: object): string {
  return "/" + "team" + "/" + "access_token_logs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /multi_factor_authn_settings/create_recovery_code(.:format) */
export function createRecoveryCodeMultiFactorAuthnSettingsPath(options?: object): string {
  return "/" + "multi_factor_authn_settings" + "/" + "create_recovery_code" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /multi_factor_authn_settings/edit(.:format) */
export function editMultiFactorAuthnSettingsPath(options?: object): string {
  return "/" + "multi_factor_authn_settings" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /multi_factor_authn_settings(.:format) */
export function multiFactorAuthnSettingsPath(options?: object): string {
  return "/" + "multi_factor_authn_settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /settings(.:format) */
export function settingsPath(options?: object): string {
  return "/" + "settings" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /introduction(.:format) */
export function userIntroductionPath(options?: object): string {
  return "/" + "introduction" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/statistics(.:format) */
export function teamStatisticsPath(options?: object): string {
  return "/" + "team" + "/" + "statistics" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/note_templates(.:format) */
export function teamSettingNoteTemplatesPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "note_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/custom_emojis(.:format) */
export function teamSettingCustomEmojisPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "custom_emojis" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/sso(.:format) */
export function teamSettingSsoPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "sso" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/multi_factor_authn(.:format) */
export function teamSettingMultiFactorAuthnPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "multi_factor_authn" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/group_manage(.:format) */
export function teamSettingGroupManagePath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "group_manage" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/outgoing_webhooks(.:format) */
export function teamSettingOutgoingWebhooksPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/outgoing_webhooks/slacks(.:format) */
export function teamSettingOutgoingWebhooksSlacksPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "slacks" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/outgoing_webhooks/slacks/new(.:format) */
export function newTeamSettingOutgoingWebhooksSlackPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "slacks" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/outgoing_webhooks/slacks/:id/edit(.:format) */
export function editTeamSettingOutgoingWebhooksSlackPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "slacks" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/settings/outgoing_webhooks/slacks/:id(.:format) */
export function teamSettingOutgoingWebhooksSlackPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "slacks" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/settings/outgoing_webhooks/microsoft_teams(.:format) */
export function teamSettingOutgoingWebhooksMicrosoftTeamsPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "microsoft_teams" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/outgoing_webhooks/microsoft_teams/new(.:format) */
export function newTeamSettingOutgoingWebhooksMicrosoftTeamPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "microsoft_teams" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/outgoing_webhooks/microsoft_teams/:id/edit(.:format) */
export function editTeamSettingOutgoingWebhooksMicrosoftTeamPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "microsoft_teams" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/settings/outgoing_webhooks/microsoft_teams/:id(.:format) */
export function teamSettingOutgoingWebhooksMicrosoftTeamPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "microsoft_teams" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/settings/outgoing_webhooks/generics(.:format) */
export function teamSettingOutgoingWebhooksGenericsPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "generics" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/outgoing_webhooks/generics/new(.:format) */
export function newTeamSettingOutgoingWebhooksGenericPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "generics" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/settings/outgoing_webhooks/generics/:id/edit(.:format) */
export function editTeamSettingOutgoingWebhooksGenericPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "generics" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/settings/outgoing_webhooks/generics/:id(.:format) */
export function teamSettingOutgoingWebhooksGenericPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "generics" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/settings/outgoing_webhooks/kibesan_image(.:format) */
export function teamSettingOutgoingWebhooksKibesanImagePath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "outgoing_webhooks" + "/" + "kibesan_image" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing(.:format) */
export function teamBillingPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/status(.:format) */
export function teamBillingStatusIndexPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/invoices(.:format) */
export function teamBillingInvoicesPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "invoices" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/invoices/:id(.:format) */
export function teamBillingInvoicePath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "invoices" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/billing/methods(.:format) */
export function teamBillingMethodsPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "methods" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/methods/new(.:format) */
export function newTeamBillingMethodPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "methods" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/methods/:id(.:format) */
export function teamBillingMethodPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "methods" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/billing/plans(.:format) */
export function teamBillingPlansPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "plans" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/emails(.:format) */
export function teamBillingEmailsPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "emails" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/emails/new(.:format) */
export function newTeamBillingEmailPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "emails" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/emails/:id/edit(.:format) */
export function editTeamBillingEmailPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "emails" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/billing/emails/:id(.:format) */
export function teamBillingEmailPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "emails" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/billing/subscription/apply_enterprise_trial_in_standard(.:format) */
export function applyEnterpriseTrialInStandardTeamBillingSubscriptionPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "subscription" + "/" + "apply_enterprise_trial_in_standard" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/subscription/edit(.:format) */
export function editTeamBillingSubscriptionPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "subscription" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/billing/subscription(.:format) */
export function teamBillingSubscriptionPath(options?: object): string {
  return "/" + "team" + "/" + "billing" + "/" + "subscription" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/members(.:format) */
export function teamMembersPath(options?: object): string {
  return "/" + "team" + "/" + "members" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/importers/qiita_team/confirm(.:format) */
export function confirmTeamImportersQiitaTeamPath(options?: object): string {
  return "/" + "team" + "/" + "importers" + "/" + "qiita_team" + "/" + "confirm" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/importers/qiita_team/history(.:format) */
export function historyTeamImportersQiitaTeamPath(options?: object): string {
  return "/" + "team" + "/" + "importers" + "/" + "qiita_team" + "/" + "history" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/importers/qiita_team(.:format) */
export function teamImportersQiitaTeamPath(options?: object): string {
  return "/" + "team" + "/" + "importers" + "/" + "qiita_team" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/importers/esa/confirm(.:format) */
export function confirmTeamImportersEsaPath(options?: object): string {
  return "/" + "team" + "/" + "importers" + "/" + "esa" + "/" + "confirm" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/importers/esa/history(.:format) */
export function historyTeamImportersEsaPath(options?: object): string {
  return "/" + "team" + "/" + "importers" + "/" + "esa" + "/" + "history" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/importers/esa(.:format) */
export function teamImportersEsaPath(options?: object): string {
  return "/" + "team" + "/" + "importers" + "/" + "esa" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/importers/docbase/history(.:format) */
export function historyTeamImportersDocbasePath(options?: object): string {
  return "/" + "team" + "/" + "importers" + "/" + "docbase" + "/" + "history" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/importers/docbase(.:format) */
export function teamImportersDocbasePath(options?: object): string {
  return "/" + "team" + "/" + "importers" + "/" + "docbase" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/export(.:format) */
export function teamExportPath(options?: object): string {
  return "/" + "team" + "/" + "export" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/manage/update_default_publish_places(.:format) */
export function updateDefaultPublishPlacesTeamManagePath(options?: object): string {
  return "/" + "team" + "/" + "manage" + "/" + "update_default_publish_places" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/manage/update_note_coediting(.:format) */
export function updateNoteCoeditingTeamManagePath(options?: object): string {
  return "/" + "team" + "/" + "manage" + "/" + "update_note_coediting" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/manage(.:format) */
export function teamManagePath(options?: object): string {
  return "/" + "team" + "/" + "manage" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/disable(.:format) */
export function teamDisablePath(options?: object): string {
  return "/" + "team" + "/" + "disable" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/security_policy(.:format) */
export function teamSecurityPolicyPath(options?: object): string {
  return "/" + "team" + "/" + "security_policy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/security_policy/ip_address_restriction(.:format) */
export function teamIpAddressRestrictionPath(options?: object): string {
  return "/" + "team" + "/" + "security_policy" + "/" + "ip_address_restriction" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/security_policy/trusted_ips(.:format) */
export function teamTrustedIpsPath(options?: object): string {
  return "/" + "team" + "/" + "security_policy" + "/" + "trusted_ips" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/security_policy/trusted_ips/:ip_addr(.:format) */
export function teamTrustedIpPath(ip_addr: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "security_policy" + "/" + "trusted_ips" + "/" + ip_addr + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["ip_addr","format"]);
}

/** /team/audit_logs(.:format) */
export function teamAuditLogsPath(options?: object): string {
  return "/" + "team" + "/" + "audit_logs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/saml2(.:format) */
export function teamSaml2Path(options?: object): string {
  return "/" + "team" + "/" + "saml2" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/saml2/metadata(.:format) */
export function teamSaml2MetadataPath(options?: object): string {
  return "/" + "team" + "/" + "saml2" + "/" + "metadata" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /saml2/sso(.:format) */
export function saml2SsoPath(options?: object): string {
  return "/" + "saml2" + "/" + "sso" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /saml2/sso_test(.:format) */
export function saml2SsoTestPath(options?: object): string {
  return "/" + "saml2" + "/" + "sso_test" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /saml2/acs(.:format) */
export function saml2AcsPath(options?: object): string {
  return "/" + "saml2" + "/" + "acs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /saml2/sign_up(.:format) */
export function saml2SignUpPath(options?: object): string {
  return "/" + "saml2" + "/" + "sign_up" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/saml2/id_providers/:id(.:format) */
export function teamSaml2IdProviderPath(id: ScalarType, options?: object): string {
  return "/" + "team" + "/" + "saml2" + "/" + "id_providers" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/saml2/id_providers(.:format) */
export function teamSaml2IdProvidersPath(options?: object): string {
  return "/" + "team" + "/" + "saml2" + "/" + "id_providers" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/members/invitation/accept(.:format) */
export function acceptTeamMemberInvitationPath(options?: object): string {
  return "/" + "team" + "/" + "members" + "/" + "invitation" + "/" + "accept" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team/members/invitation(.:format) */
export function teamMembersInvitationPath(options?: object): string {
  return "/" + "team" + "/" + "members" + "/" + "invitation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth(.:format) */
export function authPath(options?: object): string {
  return "/" + "auth" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /auth/failure(.:format) */
export function authFailurePath(options?: object): string {
  return "/" + "auth" + "/" + "failure" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /enable_sso(.:format) */
export function enableSsoPath(options?: object): string {
  return "/" + "enable_sso" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /disable_sso(.:format) */
export function disableSsoPath(options?: object): string {
  return "/" + "disable_sso" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/:id(.:format) */
export function userPath(id: ScalarType, options?: object): string {
  return "/" + "users" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /members(.:format) */
export function membersPath(options?: object): string {
  return "/" + "members" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /oauth_identity/sign_up(.:format) */
export function oauthIdentitySignUpPath(options?: object): string {
  return "/" + "oauth_identity" + "/" + "sign_up" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /blogs/:blog_id/versions/latest(.:format) */
export function latestBlogVersionsPath(blog_id: ScalarType, options?: object): string {
  return "/" + "blogs" + "/" + blog_id + "/" + "versions" + "/" + "latest" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["blog_id","format"]);
}

/** /blogs/:blog_id/versions/:id(.:format) */
export function blogVersionPath(blog_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "blogs" + "/" + blog_id + "/" + "versions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["blog_id","id","format"]);
}

/** /blogs/:id(.:format) */
export function blogPath(id: ScalarType, options?: object): string {
  return "/" + "blogs" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /blogs/:id/convert_to_wiki(.:format) */
export function blogConvertToWikiPath(id: ScalarType, options?: object): string {
  return "/" + "blogs" + "/" + id + "/" + "convert_to_wiki" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /@:account(.:format) */
export function friendlyUserPath(account: ScalarType, options?: object): string {
  return "/" + "@" + account + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["account","format"]);
}

/** /@:account/:id/present(.:format) */
export function presentBlogPath(account: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "@" + account + "/" + id + "/" + "present" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["account","id","format"]);
}

/** /@:account/:id(.:format) */
export function friendlyBlogPath(account: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "@" + account + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["account","id","format"]);
}

/** /@:account/audit_logs(.:format) */
export function personalAuditLogsPath(account: ScalarType, options?: object): string {
  return "/" + "@" + account + "/" + "audit_logs" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["account","format"]);
}

/** /folders(.:format) */
export function foldersPath(options?: object): string {
  return "/" + "folders" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /folders/:id(.:format) */
export function folderPath(id: ScalarType, options?: object): string {
  return "/" + "folders" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /notes/folder(.:format) */
export function notesFolderPath(options?: object): string {
  return "/" + "notes" + "/" + "folder" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /notes/:note_id/versions/latest(.:format) */
export function latestNoteVersionsPath(note_id: ScalarType, options?: object): string {
  return "/" + "notes" + "/" + note_id + "/" + "versions" + "/" + "latest" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["note_id","format"]);
}

/** /notes/:note_id/versions/:id(.:format) */
export function noteVersionPath(note_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "notes" + "/" + note_id + "/" + "versions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["note_id","id","format"]);
}

/** /notes/new(.:format) */
export function newNotePath(options?: object): string {
  return "/" + "notes" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /notes/:id/edit(.:format) */
export function editNotePath(id: ScalarType, options?: object): string {
  return "/" + "notes" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /notes/:original_note_id/copy(.:format) */
export function copyNotePath(original_note_id: ScalarType, options?: object): string {
  return "/" + "notes" + "/" + original_note_id + "/" + "copy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["original_note_id","format"]);
}

/** /notes/:id(.:format) */
export function notePath(id: ScalarType, options?: object): string {
  return "/" + "notes" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /notes/:id/present(.:format) */
export function presentNotePath(id: ScalarType, options?: object): string {
  return "/" + "notes" + "/" + id + "/" + "present" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /reviewable_drafts/:key(.:format) */
export function reviewableDraftPath(key: ScalarType, options?: object): string {
  return "/" + "reviewable_drafts" + "/" + key + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["key","format"]);
}

/** /preview(.:format) */
export function previewPath(options?: object): string {
  return "/" + "preview" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /note_templates/:note_template_id/notes/new(.:format) */
export function newNoteTemplateNotePath(note_template_id: ScalarType, options?: object): string {
  return "/" + "note_templates" + "/" + note_template_id + "/" + "notes" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["note_template_id","format"]);
}

/** /note_templates/new(.:format) */
export function newNoteTemplatePath(options?: object): string {
  return "/" + "note_templates" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /note_templates/:id/edit(.:format) */
export function editNoteTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "note_templates" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /note_templates/:id(.:format) */
export function noteTemplatePath(id: ScalarType, options?: object): string {
  return "/" + "note_templates" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /note_templates(.:format) */
export function noteTemplatesPath(options?: object): string {
  return "/" + "note_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /notifications(.:format) */
export function notificationsPath(options?: object): string {
  return "/" + "notifications" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /attachments(.:format) */
export function attachmentsPath(options?: object): string {
  return "/" + "attachments" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /attachments/:id(.:format) */
export function attachmentPath(id: ScalarType, options?: object): string {
  return "/" + "attachments" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /attachments/:attachment_id/file_preview(.:format) */
export function attachmentFilePreviewPath(attachment_id: ScalarType, options?: object): string {
  return "/" + "attachments" + "/" + attachment_id + "/" + "file_preview" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["attachment_id","format"]);
}

/** /editor/mentions(.:format) */
export function editorMentionsPath(options?: object): string {
  return "/" + "editor" + "/" + "mentions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /editor/code_labels(.:format) */
export function editorCodeLabelsPath(options?: object): string {
  return "/" + "editor" + "/" + "code_labels" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /shared/entries(.:format) */
export function sharedEntriesPath(options?: object): string {
  return "/" + "shared" + "/" + "entries" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /shared/entries/:id(.:format) */
export function sharedEntryPath(id: ScalarType, options?: object): string {
  return "/" + "shared" + "/" + "entries" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /shared/entries/:id/present(.:format) */
export function sharedPresentSharedEntryPath(id: ScalarType, options?: object): string {
  return "/" + "shared" + "/" + "entries" + "/" + id + "/" + "present" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /search(.:format) */
export function searchPath(options?: object): string {
  return "/" + "search" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /assistants(.:format) */
export function assistantsPath(options?: object): string {
  return "/" + "assistants" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /groups(.:format) */
export function groupsPath(options?: object): string {
  return "/" + "groups" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /groups/:id(.:format) */
export function groupPath(id: ScalarType, options?: object): string {
  return "/" + "groups" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /my_likes(.:format) */
export function myLikesPath(options?: object): string {
  return "/" + "my_likes" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /registration/finish(.:format) */
export function registrationFinishPath(options?: object): string {
  return "/" + "registration" + "/" + "finish" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /app_signin(.:format) */
export function appSigninPath(options?: object): string {
  return "/" + "app_signin" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /team_logged_in(.:format) */
export function teamLoggedInPath(options?: object): string {
  return "/" + "team_logged_in" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /zendesk/widget_token(.:format) */
export function zendeskWidgetTokenPath(options?: object): string {
  return "/" + "zendesk" + "/" + "widget_token" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /ja(.:format) */
export function jaPath(options?: object): string {
  return "/" + "ja" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /en(.:format) */
export function enPath(options?: object): string {
  return "/" + "en" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /policy_confirmation(.:format) */
export function policyConfirmationPath(options?: object): string {
  return "/" + "policy_confirmation" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /exported_files/:id(.:format) */
export function exportedFilePath(id: ScalarType, options?: object): string {
  return "/" + "exported_files" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /reset_state(.:format) */
export function resetStatePath(options?: object): string {
  return "/" + "reset_state" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /helps(.:format) */
export function helpsPath(options?: object): string {
  return "/" + "helps" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /helps/point(.:format) */
export function helpsPointPath(options?: object): string {
  return "/" + "helps" + "/" + "point" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /helps/plan(.:format) */
export function helpsPlanPath(options?: object): string {
  return "/" + "helps" + "/" + "plan" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /helps/suspension(.:format) */
export function helpsSuspensionPath(options?: object): string {
  return "/" + "helps" + "/" + "suspension" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /helps/importing(.:format) */
export function helpsImportingPath(options?: object): string {
  return "/" + "helps" + "/" + "importing" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /helps/sso(.:format) */
export function helpsSsoPath(options?: object): string {
  return "/" + "helps" + "/" + "sso" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /kibelablog(.:format) */
export function kibelablogPath(options?: object): string {
  return "/" + "kibelablog" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /api(.:format) */
export function apiPath(options?: object): string {
  return "/" + "api" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /status(.:format) */
export function statusPath(options?: object): string {
  return "/" + "status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /bitjourney(.:format) */
export function bitjourneyPath(options?: object): string {
  return "/" + "bitjourney" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /find_team(.:format) */
export function findTeamPath(options?: object): string {
  return "/" + "find_team" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /find_team/find(.:format) */
export function findTeamFindPath(options?: object): string {
  return "/" + "find_team" + "/" + "find" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /@:account/:id/edit(.:format) */
export function friendlyEditBlogPath(account: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "@" + account + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["account","id","format"]);
}

/** /blogs/:original_blog_id/copy(.:format) */
export function copyBlogPath(original_blog_id: ScalarType, options?: object): string {
  return "/" + "blogs" + "/" + original_blog_id + "/" + "copy" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["original_blog_id","format"]);
}

/** /blogs/new(.:format) */
export function newBlogPath(options?: object): string {
  return "/" + "blogs" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /wikis/:wiki_id/versions/latest(.:format) */
export function latestWikiVersionsPath(wiki_id: ScalarType, options?: object): string {
  return "/" + "wikis" + "/" + wiki_id + "/" + "versions" + "/" + "latest" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["wiki_id","format"]);
}

/** /wikis/:wiki_id/versions/:id(.:format) */
export function wikiVersionPath(wiki_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "wikis" + "/" + wiki_id + "/" + "versions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["wiki_id","id","format"]);
}

/** /wikis/:id/edit(.:format) */
export function editWikiPath(id: ScalarType, options?: object): string {
  return "/" + "wikis" + "/" + id + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /wikis/:id/present(.:format) */
export function presentWikiPath(id: ScalarType, options?: object): string {
  return "/" + "wikis" + "/" + id + "/" + "present" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /wikis/*folders/:id(.:format) */
export function friendlyWikiPath(folders: ScalarType[], id: ScalarType, options?: object): string {
  return "/" + "wikis" + "/" + folders.map((part) => $encode(part)).join("/") + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["folders","id","format"]);
}

/** /boards(.:format) */
export function boardsPath(options?: object): string {
  return "/" + "boards" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /boards/:id(.:format) */
export function boardPath(id: ScalarType, options?: object): string {
  return "/" + "boards" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["id","format"]);
}

/** /team/settings/wiki_templates(.:format) */
export function teamSettingWikiTemplatesPath(options?: object): string {
  return "/" + "team" + "/" + "settings" + "/" + "wiki_templates" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /wiki_templates/new(.:format) */
export function wikiTemplatesNewPath(options?: object): string {
  return "/" + "wiki_templates" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /boards/:board_id/users/search(.:format) */
export function searchBoardUsersPath(board_id: ScalarType, options?: object): string {
  return "/" + "boards" + "/" + board_id + "/" + "users" + "/" + "search" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["board_id","format"]);
}

/** /boards/:board_id/users(.:format) */
export function boardUsersPath(board_id: ScalarType, options?: object): string {
  return "/" + "boards" + "/" + board_id + "/" + "users" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["board_id","format"]);
}

/** /boards/:board_id/headnote/versions(.:format) */
export function boardHeadnoteVersionsPath(board_id: ScalarType, options?: object): string {
  return "/" + "boards" + "/" + board_id + "/" + "headnote" + "/" + "versions" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["board_id","format"]);
}

/** /boards/:board_id/headnote/versions/:id(.:format) */
export function boardHeadnoteVersionPath(board_id: ScalarType, id: ScalarType, options?: object): string {
  return "/" + "boards" + "/" + board_id + "/" + "headnote" + "/" + "versions" + "/" + id + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["board_id","id","format"]);
}

/** /boards/:board_id/headnote/edit(.:format) */
export function editBoardHeadnotePath(board_id: ScalarType, options?: object): string {
  return "/" + "boards" + "/" + board_id + "/" + "headnote" + "/" + "edit" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["board_id","format"]);
}

/** /boards/:board_id/headnote(.:format) */
export function boardHeadnotePath(board_id: ScalarType, options?: object): string {
  return "/" + "boards" + "/" + board_id + "/" + "headnote" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["board_id","format"]);
}

/** /stripe/incoming_webhook(.:format) */
export function stripeIncomingWebhookPath(options?: object): string {
  return "/" + "stripe" + "/" + "incoming_webhook" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /register(.:format) */
export function registerPath(options?: object): string {
  return "/" + "register" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /registration/new(.:format) */
export function registrationNewPath(options?: object): string {
  return "/" + "registration" + "/" + "new" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /registration(.:format) */
export function registrationPath(options?: object): string {
  return "/" + "registration" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /registration/signup(.:format) */
export function registrationSignupPath(options?: object): string {
  return "/" + "registration" + "/" + "signup" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /registration/user(.:format) */
export function registrationUserPath(options?: object): string {
  return "/" + "registration" + "/" + "user" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /registration/team_setting(.:format) */
export function registrationTeamSettingPath(options?: object): string {
  return "/" + "registration" + "/" + "team_setting" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /registration/invitations(.:format) */
export function registrationInvitationsPath(options?: object): string {
  return "/" + "registration" + "/" + "invitations" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /registration/status(.:format) */
export function registrationStatusPath(options?: object): string {
  return "/" + "registration" + "/" + "status" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/auth/google(.:format) */
export function userGoogleOmniauthAuthorizePath(options?: object): string {
  return "/" + "users" + "/" + "auth" + "/" + "google" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /users/auth/google/callback(.:format) */
export function userGoogleOmniauthCallbackPath(options?: object): string {
  return "/" + "users" + "/" + "auth" + "/" + "google" + "/" + "callback" + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["format"]);
}

/** /scripts/:token(.:format) */
export function scriptPath(token: ScalarType, options?: object): string {
  return "/" + "scripts" + "/" + token + ($hasPresentOwnProperty(options, "format") ? "." + (options as any).format : "") + $buildOptions(options, ["token","format"]);
}

/** / */
export function rootPath(options?: object): string {
  return "/" + $buildOptions(options, []);
}
